export const tableSelect = [
    {
        name: 'Cell'
    },
    {
        name: 'Row'
    },
    {
        name: 'Table'
    }
]

export const chooseCalc = [
    {
        year: [
            '2026',
            '2025',
            '2024',
            '2023',
            '2022',
            '2021',
            '2020'
        ],
        location: [
            'Federal',
            'California'
        ],
        status: [
            'Single',
            'Married Filing Separate',
            'Married Filing Joint',
            'Unmarried Head of Household'
        ]
    }
]
